// src/utils/textUtils.js

export const sanitizeForDisplay = (text) => {
  if (!text) return '';

  return text
    .replace(/【\d+:\d+†[^】]+】/g, '')           // Quita referencias tipo  
    .replace(/【\d+†source】/g, '')              // Quita referencias tipo  
    .replace(/\*/g, '')                         // Quita asteriscos
    .replace(/^#+\s/gm, '')                     // Quita encabezados markdown
    .replace(/```[\s\S]*?```/g, '[código]')     // Quita bloques de código
    .replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '$1 ($2)')  // Muestra texto y URL entre paréntesis
    // .replace(/https?:\/\/[^\s]+/g, '[enlace]') // ❌ Comentado: deja las URLs planas visibles
    .replace(/\n{2,}/g, '\n')                   // Compacta saltos de línea
    .trim();
};

